package com.appsyde.shared.presentation.style.style

import com.appsyde.shared.presentation.style.token.AppStylesTokens
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.StyleSheet
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flexDirection
import org.jetbrains.compose.web.css.flexShrink
import org.jetbrains.compose.web.css.flexWrap
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.justifyContent
import org.jetbrains.compose.web.css.lineHeight
import org.jetbrains.compose.web.css.marginBottom
import org.jetbrains.compose.web.css.marginTop
import org.jetbrains.compose.web.css.maxWidth
import org.jetbrains.compose.web.css.minHeight
import org.jetbrains.compose.web.css.minWidth
import org.jetbrains.compose.web.css.paddingLeft
import org.jetbrains.compose.web.css.paddingRight
 import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.paddingBottom
import org.jetbrains.compose.web.css.paddingTop
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
 import org.jetbrains.compose.web.css.width

object AppStylesAccount : StyleSheet() {


    /** Carte principale (Mon compte) : prend l’espace restant. */




    /** Titre de section configuration : hiérarchie claire. 24px sous le titre. */
    val sectionTitle by style {
        fontSize(15.px)
        fontWeight(700)
        color(Color("rgba(15,23,42,0.9)"))
        marginBottom(24.px)
    }

    /** 24px entre sections majeures (Ton IA vs Signature). */
    val fieldsGrid by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(24.px)
        minWidth(0.px)
    }

    /** Ligne champ : label au-dessus de la valeur. 8px entre label et champ. */
    val fieldRow by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        alignItems(AlignItems.FlexStart)
        gap(8.px)
        padding(0.px)
        border(0.px)
    }

    /** Dernière ligne d'un bloc (pour compatibilité, plus de bordure sur les rows). */
    val fieldRowLast by style {}

    /** Label de champ (Nom d'agent, Compte connecté, Plan actuel) : même style, discret. */
    val fieldLabel by style {
        fontSize(12.px)
        fontWeight(500)
        color(Color("rgba(15,23,42,0.62)"))
    }

    /** Valeur de champ : même style pour tous les champs, un peu moins fort. */
    val fieldValue by style {
        fontSize(14.px)
        fontWeight(500)
        color(Color("rgba(15,23,42,0.82)"))
        property("word-break", "break-word")
        minWidth(0.px)
    }

    /** 16px entre éléments d'une même section (label, slider, légende, hint). */
    val toneRow by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(16.px)
        padding(0.px)
        minWidth(0.px)
    }

    val toneHead by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(10.px)
    }

    val toneSlider by style {
        width(100.percent)
        property("height", "8px")
        property("padding", "0")
        property("cursor", "pointer")
    }

    /** Slider premium (track 4px) pour Mon compte. */
    val toneSliderPremium by style {
        width(100.percent)
        height(4.px)
        property("padding", "0")
        property("cursor", "pointer")
        property("appearance", "none")
        property("-webkit-appearance", "none")
        backgroundColor(Color("rgba(15,23,42,0.08)"))
        borderRadius(999.px)
    }

    val toneLegend by style {
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.SpaceBetween)
        alignItems(AlignItems.Center)
        gap(8.px)
    }

    val toneLegendItem by style {
        fontSize(11.5.px)
        fontWeight(500)
        color(Color("rgba(15,23,42,0.62)"))
        property("transition", AppStylesTokens.TRANSITION_FAST)
    }

    val toneLegendItemActive by style {
        color(Color("rgba(59,70,212,0.82)"))
        fontWeight(600)
    }

    /** Reset bouton pour les labels de ton (cliquables, aspect texte). */
    val toneLegendButton by style {
        border(0.px)
        backgroundColor(Color.transparent)
        property("cursor", "pointer")
        padding(0.px, 4.px)
    }

    val toneHint by style {
        fontSize(12.px)
        fontWeight(400)
        color(Color("rgba(15,23,42,0.65)"))
        lineHeight("1.5")
    }

    /** Bloc signature : 24px au-dessus (section majeure), 16px entre éléments. */
    val signatureWrap by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(16.px)
        padding(0.px)
        marginTop(24.px)
        paddingTop(24.px)
        property("border-top", "1px solid rgba(15,23,42,0.08)")
        minWidth(0.px)
    }

    val signatureToggleRow by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(10.px)
    }

    val signatureLabelWithToggle by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(10.px)
    }

    val signatureToggle by style {
        width(44.px)
        height(24.px)
        borderRadius(999.px)
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.12)"))
        backgroundColor(Color("rgba(15,23,42,0.16)"))
        property("appearance", "none")
        property("cursor", "pointer")
        property("position", "relative")
        property("transition", AppStylesTokens.TRANSITION_FAST)
    }

    val signatureToggleOn by style {
        backgroundColor(Color(AppStylesTokens.BRAND))
        border(1.px, LineStyle.Solid, Color(AppStylesTokens.BRAND))
    }

    val signatureToggleThumb by style {
        width(18.px)
        height(18.px)
        borderRadius(50.percent)
        backgroundColor(Color("#FFFFFF"))
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.10)"))
        property("box-shadow", "0 1px 3px rgba(15,23,42,0.12)")
        property("transform", "translateX(0)")
        property("transition", AppStylesTokens.TRANSITION_FAST)
        property("pointer-events", "none")
    }

    val signatureToggleThumbOn by style {
        property("transform", "translateX(20px)")
    }

    val signatureInput by style {
        width(100.percent)
        minWidth(0.px)
        padding(0.px)
        borderRadius(10.px)
        border(0.px)
        backgroundColor(Color("transparent"))
        color(Color("rgba(15,23,42,0.88)"))
        fontSize(12.5.px)
        fontWeight(400)
        lineHeight("1.62")
        property("resize", "none")
        property("min-height", "52px")
        property("outline", "none")
        property("font-family", AppStylesTokens.FONT_FAMILY)
        property("letter-spacing", "0")
        property("caret-color", AppStylesTokens.PURPLE)
        property("overflow", "hidden")
    }

    val signatureInputDisabled by style {
        backgroundColor(Color("rgba(15,23,42,0.03)"))
        color(Color("rgba(15,23,42,0.45)"))
    }

    /** Boutons de bloc : 16px au-dessus (même section). */
    val actionsRow by style {
        display(DisplayStyle.Flex)
        flexWrap(FlexWrap.Wrap)
        gap(12.px)
        paddingTop(16.px)
        paddingBottom(14.px)
         property("border-bottom", "1px solid rgba(15,23,42,0.06)")
    }

    /** Boutons secondaires (Déconnexion, Gérer l'abonnement) : bien visibles, premium. */
    val actionGhost by style {  
        padding(10.px, 16.px)
        borderRadius(10.px)
        border(1.5.px, LineStyle.Solid, Color("rgba(15,23,42,0.14)"))
        backgroundColor(Color("rgba(255,255,255,0.98)"))
        color(Color("rgba(15,23,42,0.82)"))
        fontSize(13.px)
        fontWeight(600)
        property("cursor", "pointer")
        property("transition", AppStylesTokens.TRANSITION_FAST)
        property("box-shadow", "0 1px 2px rgba(15,23,42,0.04)")
    }

    /** Bouton destructif : rouge maîtrisé (couleur précédente). */
    val actionDanger by style {
        padding(10.px, 16.px)
        borderRadius(10.px)
        border(1.px, LineStyle.Solid, Color("rgba(220,38,38,0.18)"))
        backgroundColor(Color("rgba(239,68,68,0.06)"))
        color(Color("rgba(153,27,27,0.86)"))
        fontSize(13.px)
        fontWeight(600)
        property("cursor", "pointer")
        property("transition", AppStylesTokens.TRANSITION_FAST)
    }

    /** Équipe : ligne email + bouton Envoyer. */

    val teamInviteButton by style {
        padding(10.px, 16.px)
        borderRadius(10.px)
        border(0.px)
        backgroundColor(Color("rgba(59,70,212,0.9)"))
        color(Color.white)
        fontSize(13.px)
        fontWeight(600)
        property("cursor", "pointer")
    }
    val teamMessageOk by style {
        marginTop(8.px)
        fontSize(13.px)
        color(Color("rgba(15,23,42,0.75)"))
    }
    val teamMessageError by style {
        marginTop(8.px)
        fontSize(13.px)
        color(Color("rgba(220,38,38,0.9)"))
    }
    val teamList by style {
        property("list-style", "none")
        padding(0.px)
        property("margin", "0")
    }
    val teamListItem by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.SpaceBetween)
        gap(12.px)
        padding(8.px, 0.px)
        border(0.px)
    }

    val cardTitle by style {
        fontSize(17.px)
        fontWeight(600)
        color(Color("rgba(15,23,42,0.9)"))
    }

    /** Bouton Déconnexion en haut à droite de la carte Mon compte : petit secondaire discret. */
    val cardHeaderLogoutButton by style {
        padding(6.px, 12.px)
        borderRadius(10.px)
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.1)"))
        backgroundColor(Color("rgba(255,255,255,0.7)"))
        color(Color("rgba(15,23,42,0.7)"))
        fontSize(12.5.px)
        fontWeight(500)
        property("cursor", "pointer")
        property("transition", AppStylesTokens.TRANSITION_FAST)
        self + hover style {
            backgroundColor(Color("rgba(15,23,42,0.06)"))
            color(Color("rgba(15,23,42,0.85)"))
        }
    }

    val cardSub by style {
        marginTop(6.px)
        fontSize(13.px)
        fontWeight(400)
        color(Color("rgba(15,23,42,0.6)"))
        lineHeight("1.45")
        maxWidth(100.percent)
    }

    // ---------- Card latérale (comme TicketsSidebar : panelCard séparée) ----------
    /** Card latérale : Profil, Abonnement, Sécurité/Compte (même rôle que la card "Voir ce ticket"). */
    val accountLateralCard by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(0.px)
        minWidth(0.px)
    }

    /** Corps de la card latérale : espacement premium. */
    val accountLateralCardBody by style {
        padding(24.px)
        property("flex", "1")
        minWidth(0.px)
        property("overflow-y", "auto")
    }

    /** Contenu de la card latérale : 24px entre sections majeures (Profil, Abonnement, Gestion). */
    val accountSidebar by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(24.px)
        minWidth(0.px)
    }

    /** Divider entre blocs (Profil / Abonnement / Gestion). Respecte le gap 24px du parent. */
    val accountSidebarDivider by style {
        width(100.percent)
        minWidth(0.px)
        property("border-top", "1px solid rgba(15,23,42,0.08)")
        property("flex-shrink", "0")
    }

    /** Bloc de catégorie dans la sidebar : 16px entre éléments d'une même section. */
    val accountSidebarBlock by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(16.px)
        minWidth(0.px)
    }

    /** Titre de catégorie dans la sidebar (couleur Appsyde, léger contraste). */
    val accountSidebarBlockTitle by style {
        fontSize(13.px)
        fontWeight(600)
        color(Color(AppStylesTokens.NAV_ACTIVE))
        marginBottom(0.px)
    }

    /** Gestion du compte : 16px entre titre et bouton. */
    val accountDangerZoneBlock by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(16.px)
        minWidth(0.px)
    }

    val accountDangerZoneTitle by style {
        fontSize(13.px)
        fontWeight(600)
        color(Color(AppStylesTokens.NAV_ACTIVE))
        marginBottom(0.px)
    }

    /** Message après envoi demande suppression (succès ou erreur). */
    val deleteRequestMessage by style {
        padding(10.px, 12.px)
        borderRadius(10.px)
        backgroundColor(Color("rgba(15,23,42,0.04)"))
        fontSize(12.5.px)
        color(Color("rgba(15,23,42,0.78)"))
        marginBottom(8.px)
    }

    // ---------- Modal suppression de compte ----------
    val deleteAccountModalOverlay by style {
        property("position", "fixed")
        property("inset", "0")
        property("z-index", "1000")
        backgroundColor(Color("rgba(15,23,42,0.45)"))
        display(DisplayStyle.Flex)
        property("align-items", "center")
        property("justify-content", "center")
        padding(24.px)
    }

    val deleteAccountModalDialog by style {
        backgroundColor(Color.white)
        borderRadius(16.px)
        padding(32.px)
        property("max-width", "460px")
        property("width", "100%")
        property("box-shadow", "0 20px 50px rgba(15,23,42,0.2)")
    }

    val deleteAccountModalTitle by style {
        fontSize(18.px)
        fontWeight(600)
        color(Color("rgba(15,23,42,0.9)"))
        marginBottom(20.px)
    }

    val deleteAccountModalBody by style {
        fontSize(13.px)
        fontWeight(400)
        color(Color("rgba(15,23,42,0.72)"))
        lineHeight("1.55")
        marginBottom(24.px)
    }

    /** Bloc sémantique (ex. « Ce qui sera supprimé » + liste) avec espace en dessous. */
    val deleteAccountModalSection by style {
        marginBottom(20.px)
    }

    /** Sous-titre de section (semi-bold) pour hiérarchiser le contenu. */
    val deleteAccountModalSubheading by style {
        fontSize(13.px)
        fontWeight(600)
        color(Color("rgba(15,23,42,0.82)"))
        marginBottom(8.px)
    }

    val deleteAccountModalList by style {
        marginTop(6.px)
        marginBottom(0.px)
        property("padding-left", "20px")
    }

    val deleteAccountModalListItem by style {
        marginBottom(8.px)
    }

    /** Paragraphe de conclusion (irréversible, confirmation email) avec espace au-dessus. */
    val deleteAccountModalParagraph by style {
        marginTop(14.px)
    }

    val deleteAccountModalButtons by style {
        display(DisplayStyle.Flex)
        property("flex-direction", "row")
        property("justify-content", "flex-end")
        gap(10.px)
        marginTop(8.px)
    }

    val deleteAccountModalButtonSecondary by style {
        padding(10.px, 16.px)
        borderRadius(10.px)
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.12)"))
        backgroundColor(Color("rgba(255,255,255,0.9)"))
        color(Color("rgba(15,23,42,0.78)"))
        fontSize(13.px)
        fontWeight(500)
        property("cursor", "pointer")
        property("transition", AppStylesTokens.TRANSITION_FAST)
    }

    /** Rouge profond, moins saturé = action critique maîtrisée (premium). */
    val deleteAccountModalButtonPrimary by style {
        padding(10.px, 16.px)
        borderRadius(10.px)
        border(1.px, LineStyle.Solid, Color("rgba(127,29,29,0.35)"))
        backgroundColor(Color("rgba(127,29,29,0.94)"))
        color(Color.white)
        fontSize(13.px)
        fontWeight(500)
        property("cursor", "pointer")
        property("transition", AppStylesTokens.TRANSITION_FAST)
    }

    // ---------- Page publique confirmation suppression ----------
    val confirmDeletionPageWrap by style {
        display(DisplayStyle.Flex)
        property("align-items", "center")
        property("justify-content", "center")
        property("min-height", "100vh")
        padding(24.px)
        backgroundColor(Color("rgba(15,23,42,0.04)"))
    }

    val confirmDeletionCard by style {
        backgroundColor(Color.white)
        borderRadius(16.px)
        padding(40.px, 32.px)
        property("max-width", "560px")
        property("width", "100%")
        property("box-shadow", "0 20px 50px rgba(15,23,42,0.12)")
    }

    // ---------- Page invitation (UI app, densité maîtrisée, ton outil) ----------
    /** Header invite : même hauteur que le header normal (46px). */
    val invitePageHeaderInner by style {
        height(46.px)
        maxWidth(1480.px)
        property("margin-left", "auto")
        property("margin-right", "auto")
        paddingLeft(26.px)
        paddingRight(26.px)
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.SpaceBetween)
    }

    val invitePageHeaderRight by style {
        fontSize(13.px)
        fontWeight(500)
        color(Color("#6B7280"))
    }

    /** Wrapper card : max 640px, centré. */
    val inviteCardWrap by style {
        width(100.percent)
        maxWidth(640.px)
        minWidth(0.px)
    }

    /** Card centrale : padding 34px, bordure + ombre douces. */
    val inviteCard by style {
        backgroundColor(Color(AppStylesTokens.CARD))
        borderRadius(16.px)
        property("border", "1px solid rgba(15,23,42,0.06)")
        property("box-shadow", "0 4px 20px rgba(15,23,42,0.06)")
        padding(34.px)
        width(100.percent)
        minWidth(0.px)
    }

    /** Contenu aligné à gauche (carte centrée, contenu start). */
    val inviteCardInner by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        alignItems(AlignItems.FlexStart)
        property("text-align", "left")
        width(100.percent)
    }

    /** Row [ icon ] + titre, alignés à gauche, gap 14px. Espace sous la row = 20px. */
    val inviteTitleRow by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Row)
        alignItems(AlignItems.Center)
        gap(14.px)
        marginBottom(20.px)
    }

    /** Fond circulaire derrière l’icône (violet 6%). */
    /** Badge carré arrondi 44px (style app). */
    val inviteHeroBadge by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        width(44.px)
        height(44.px)
        flexShrink(0)
        borderRadius(12.px)
        backgroundColor(Color("rgba(107,114,128,0.08)"))
        property("border", "1px solid rgba(15,23,42,0.06)")
    }

    val inviteHeroBadgeIcon by style {
        fontSize(22.px)
        property("line-height", "1")
    }

    /** Ancien style circulaire (NoWorkspaceScreen). */
    val inviteHeroIconWrap by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        width(72.px)
        height(72.px)
        borderRadius(50.percent)
        backgroundColor(Color("rgba(102,96,230,0.06)"))
        marginBottom(24.px)
    }

    val inviteHeroIcon by style {
        fontSize(40.px)
        property("opacity", "0.92")
    }

    /** Titre : un seul point fort visuel, 24px, weight 600. */
    val inviteTitle by style {
        fontSize(24.px)
        fontWeight(600)
        color(Color(AppStylesTokens.INK))
        property("letter-spacing", "-0.02em")
        property("line-height", "1.25")
    }

    /** Paragraphe explicatif : 15px, normal, respiration. */
    val inviteDescription by style {
        fontSize(15.px)
        fontWeight(400)
        color(Color("#6B7280"))
        lineHeight("1.65")
        marginBottom(16.px)
    }

    /** Nom invitant : normal (400), pas de bold pour éviter la tension visuelle. */
    val inviteInviterName by style {
        fontWeight(400)
        color(Color(AppStylesTokens.INK))
    }

    /** Bloc Boîte support : léger, pas de fond, bordure douce. */
    val inviteSupportBlock by style {
        width(100.percent)
        padding(12.px, 0.px)
        backgroundColor(Color.transparent)
        property("border-bottom", "1px solid rgba(15,23,42,0.08)")
        marginTop(8.px)
        marginBottom(28.px)
        property("text-align", "left")
    }

    val inviteSupportLabel by style {
        fontSize(11.px)
        fontWeight(500)
        color(Color("#9CA3AF"))
        property("letter-spacing", "0.04em")
        property("text-transform", "uppercase")
        marginBottom(6.px)
    }

    val inviteSupportValue by style {
        fontSize(15.px)
        fontWeight(500)
        color(Color(AppStylesTokens.INK))
    }

    val inviteError by style {
        fontSize(14.px)
        color(Color("#B45309"))
        marginBottom(14.px)
    }

    /** Zone CTA : bouton + lien secondaire, alignés à gauche, respiration. */
    val inviteActionWrap by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Row)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.FlexStart)
        flexWrap(FlexWrap.Wrap)
        gap(12.px)
        marginBottom(20.px)
    }

    val inviteActionSpacer by style { width(8.px) }

    /** Bouton primary : hauteur mesurée, il respire. */
    val inviteBtnPrimary by style {
        padding(10.px, 18.px)
        borderRadius(10.px)
        border(0.px)
        backgroundColor(Color(AppStylesTokens.BRAND))
        color(Color.white)
        fontSize(15.px)
        fontWeight(600)
        property("cursor", "pointer")
        property("transition", "transform 120ms ease, background-color 160ms ease")
        self + hover style {
            backgroundColor(Color(AppStylesTokens.NAV_ACTIVE))
            property("transform", "translateY(-1px)")
        }
        self + active style { property("transform", "translateY(0)") }
    }

    /** Lien secondaire : violet, 500, pas trop présent. */
    val inviteLinkSecondary by style {
        fontSize(14.px)
        fontWeight(500)
        color(Color(AppStylesTokens.BRAND))
        property("cursor", "pointer")
        backgroundColor(Color.transparent)
        border(0.px)
        self + hover style { property("text-decoration", "underline") }
    }

    /** Trust row : espace au-dessus 20px, calme. */
    val inviteTrustRow by style {
        paddingTop(20.px)
        property("border-top", "1px solid rgba(15,23,42,0.06)")
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.FlexStart)
        gap(8.px)
        fontSize(13.px)
        fontWeight(400)
        color(Color("#6B7280"))
        lineHeight("1.5")
    }

    val inviteTrustCheck by style {
        display(DisplayStyle.LegacyInlineFlex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        width(20.px)
        height(20.px)
        borderRadius(50.percent)
        backgroundColor(Color("rgba(34,197,94,0.12)"))
        color(Color("#16a34a"))
        fontSize(12.px)
        fontWeight(700)
    }

    /** Header invite / no-workspace : brand plus discret (opacity). */
    val inviteHeaderDiscreet by style {
        property("opacity", "0.72")
    }

    val confirmDeletionTitle by style {
        fontSize(20.px)
        fontWeight(600)
        color(Color("rgba(15,23,42,0.9)"))
        marginBottom(8.px)
    }

    val confirmDeletionSubtext by style {
        fontSize(13.px)
        color(Color("rgba(15,23,42,0.6)"))
        marginBottom(24.px)
    }

    val confirmDeletionBody by style {
        fontSize(13.px)
        color(Color("rgba(15,23,42,0.72)"))
        lineHeight("1.5")
    }

    /** Section avec plus d’espace entre les blocs (respiration). */
    val confirmDeletionSection by style {
        marginBottom(26.px)
    }

    /** Bloc « Compte concerné » : label sans « : », espace vertical réduit. */
    val confirmDeletionAccountBlock by style {
        marginBottom(22.px)
    }

    val confirmDeletionAccountLabel by style {
        fontSize(13.px)
        fontWeight(600)
        color(Color("rgba(15,23,42,0.82)"))
        marginBottom(4.px)
    }

    val confirmDeletionAccountEmail by style {
        fontSize(14.px)
        fontWeight(600)
        color(Color("rgba(15,23,42,0.88)"))
    }

    /** Liste bullets page confirmation : line-height un peu augmenté. */
    val confirmDeletionList by style {
        marginTop(6.px)
        marginBottom(0.px)
        property("padding-left", "20px")
        lineHeight("1.55")
    }

    val confirmDeletionListItem by style {
        marginBottom(8.px)
    }

    /** Label « Pour confirmer, tapez SUPPRIMER » + plus d’espace avant l’input. */
    val confirmDeletionConfirmLabel by style {
        marginBottom(12.px)
    }

    val confirmDeletionInput by style {
        padding(12.px, 14.px)
        borderRadius(10.px)
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.12)"))
        fontSize(14.px)
        property("width", "100%")
        property("box-sizing", "border-box")
        property("transition", AppStylesTokens.TRANSITION_FAST)
    }

    val confirmDeletionInputFocus by style {
        border(1.px, LineStyle.Solid, Color(AppStylesTokens.BRAND))
        property("box-shadow", "0 0 0 2px ${AppStylesTokens.BRAND_SOFT}")
        property("outline", "none")
    }

    /** Boutons : Annuler (secondaire) + Supprimer définitivement (rouge), alignés à droite. */
    val confirmDeletionButtons by style {
        display(DisplayStyle.Flex)
        property("flex-direction", "row")
        property("justify-content", "flex-end")
        alignItems(AlignItems.Center)
        gap(12.px)
        marginTop(12.px)
    }

    val confirmDeletionButtonSecondary by style {
        padding(10.px, 16.px)
        borderRadius(10.px)
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.12)"))
        backgroundColor(Color.transparent)
        color(Color("rgba(15,23,42,0.78)"))
        fontSize(13.px)
        fontWeight(500)
        property("cursor", "pointer")
        property("transition", AppStylesTokens.TRANSITION_FAST)
    }

    val confirmDeletionBold by style {
        fontWeight(600)
    }

    // ---------- Mon compte : même layout que Respond (container 280px | 1fr | 300px), colonne droite vide ----------
    /** Card menu (Profil, Configuration, etc.) : remplit la colonne gauche comme SideBarMenu. */
    val accountNavCardWrap by style {
        width(100.percent)
        minWidth(0.px)
    }

    /** Card partie centrale : même taille que la colonne Respond (pageCardGlass, remplit mainColumn). */
    val accountCentralCardWrap by style {
        width(100.percent)
        minWidth(0.px)
        minHeight(0.px)
    }

    /** Sidebar premium : sections avec labels uppercase discrets. */
    val accountNavMinimal by style {
        paddingTop(12.px)
        paddingBottom(24.px)
        paddingLeft(12.px)
        paddingRight(12.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(2.px)
        minWidth(0.px)
    }

    /** Label de section : Paramètres, Équipe — plus fort, lisible. */
    val accountNavSectionLabel by style {
        fontSize(13.px)
        fontWeight(700)
        color(Color("rgba(15,23,42,0.88)"))
        marginTop(16.px)
        marginBottom(6.px)
        paddingLeft(0.px)
        property("border", "none")
        backgroundColor(Color.transparent)
    }

    val accountNavSectionLabelFirst by style {
        marginTop(0.px)
    }

    val accountNavItem by style {
        padding(10.px, 12.px)
        fontSize(14.px)
        fontWeight(500)
        color(Color("rgba(15,23,42,0.65)"))
        property("cursor", "pointer")
        property("border", "none")
        backgroundColor(Color.transparent)
        property("text-align", "left")
        property("transition", "color 140ms ease, background-color 140ms ease")
        property("margin-left", "-12px")
        property("border-radius", "6px")
        self + hover style { color(Color("rgba(15,23,42,0.88)")) }
    }

    /** État actif : fond très léger, texte plus bold (sans rail). */
    val accountNavItemActive by style {
        color(Color(AppStylesTokens.BRAND))
        fontWeight(600)
        backgroundColor(Color("rgba(102,96,230,0.04)"))
    }

    /** Zone scrollable contenu central : max-width réduite pour respiration, padding généreux. */
    val accountContentWrap by style {
        paddingTop(32.px)
        paddingBottom(56.px)
        paddingLeft(40.px)
        paddingRight(40.px)
        width(100.percent)
        minWidth(0.px)
        property("overflow-y", "auto")
        property("box-sizing", "border-box")
    }

    // ---------- Profil : structure narrée (header incarné, sections distinctes) ----------
    /** Sous-titre global sous "Profil" : donne le sens de l'écran. */
    val profilePageSubtitle by style {
        fontSize(13.px)
        fontWeight(400)
        color(Color("rgba(15,23,42,0.55)"))
        lineHeight("1.5")
        marginTop(4.px)
        marginBottom(0.px)
    }

    /** Divider sous le sous-texte "Gérez votre identité…" : marges pour respirer. */
    val profileHeaderDivider by style {
        marginTop(20.px)
        marginBottom(32.px)
        property("border-top", "1px solid rgba(15,23,42,0.08)")
    }

    /** Bloc identité : nom + rôle + sous-texte (sans avatar). */
    val profileIdentityBlock by style {
        marginBottom(56.px)
    }

    /** Ligne : (cercle initiales + nom) à gauche, badge rôle à droite. */
    val profileIdentityNameRow by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Row)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.SpaceBetween)
        gap(12.px)
        marginBottom(4.px)
        minWidth(0.px)
    }

    /** Groupe cercle + nom (alignés). */
    val profileIdentityNameWrap by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Row)
        alignItems(AlignItems.Center)
        gap(12.px)
        minWidth(0.px)
    }

    /** Cercle coloré avec initiales (même système que sidebar/row). */
    val profileAvatarCircle by style {
        width(40.px)
        height(40.px)
        borderRadius(50.percent)
        backgroundColor(Color("rgba(102,96,230,0.18)"))
        color(Color("rgba(59,70,212,0.95)"))
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        flexShrink(0)
    }

    val profileAvatarCircleText by style {
        fontSize(14.px)
        fontWeight(700)
        property("letter-spacing", "0.02em")
        property("line-height", "1")
    }

    val profileIdentityName by style {
        fontSize(19.px)
        fontWeight(500)
        color(Color("rgba(15,23,42,0.92)"))
        property("letter-spacing", "-0.01em")
        marginBottom(4.px)
    }

    val profileIdentityRoleLine by style {
        fontSize(14.px)
        fontWeight(400)
        color(Color("rgba(15,23,42,0.65)"))
        lineHeight("1.4")
        marginBottom(8.px)
    }

    val profileIdentitySubtext by style {
        fontSize(13.px)
        fontWeight(400)
        color(Color("rgba(15,23,42,0.52)"))
        lineHeight("1.5")
    }

    /** Section profil : titre + contenu, plus d’espace entre sections qu’entre lignes. */
    val profileSection by style {
        marginBottom(56.px)
    }

    val profileSectionTitle by style {
        fontSize(12.px)
        fontWeight(600)
        color(Color("rgba(15,23,42,0.55)"))
        property("letter-spacing", "0.04em")
        marginBottom(8.px)
    }

    /** Ligne titre de section + badge aligné à droite (ex. "Votre rôle" | [Membre]). */
    val profileSectionTitleRow by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Row)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.SpaceBetween)
        gap(12.px)
        marginBottom(8.px)
        minWidth(0.px)
    }

    val profileSectionTitleInRow by style {
        fontSize(12.px)
        fontWeight(600)
        color(Color("rgba(15,23,42,0.55)"))
        property("letter-spacing", "0.04em")
        flexShrink(0)
    }

    val profileSectionDescription by style {
        fontSize(13.px)
        fontWeight(400)
        color(Color("rgba(15,23,42,0.65)"))
        lineHeight("1.55")
        marginBottom(12.px)
    }

    /** Badge rôle (Membre / Propriétaire). */
    val profileRoleBadge by style {
        display(DisplayStyle.InlineBlock)
        padding(6.px, 12.px)
        borderRadius(8.px)
        fontSize(12.px)
        fontWeight(600)
        color(Color("rgba(15,23,42,0.75)"))
        backgroundColor(Color("rgba(15,23,42,0.06)"))
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.1)"))
    }

    /** Mini carte boîte Gmail : accent gauche + fond légèrement plus contrasté (indice central). */
    val profileMailboxCard by style {
        padding(20.px, 18.px, 20.px, 20.px)
        borderRadius(12.px)
        backgroundColor(Color("rgba(15,23,42,0.045)"))
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.09)"))
        property("border-left", "3px solid rgba(102,96,230,0.28)")
        marginTop(4.px)
    }

    val profileMailboxTitle by style {
        fontSize(12.px)
        fontWeight(600)
        color(Color("rgba(15,23,42,0.55)"))
        property("letter-spacing", "0.02em")
        marginBottom(6.px)
    }

    val profileMailboxEmail by style {
        fontSize(15.px)
        fontWeight(500)
        color(Color("rgba(15,23,42,0.88)"))
        marginBottom(4.px)
    }

    val profileMailboxHint by style {
        fontSize(12.px)
        fontWeight(400)
        color(Color("rgba(15,23,42,0.5)"))
        lineHeight("1.4")
    }

    /** Section Sécurité : zone sensible, fond rouge très léger. */
    val profileSecuritySection by style {
        marginTop(32.px)
        paddingTop(28.px)
        padding(20.px, 18.px)
        borderRadius(12.px)
        backgroundColor(Color("rgba(220,38,38,0.04)"))
        border(1.px, LineStyle.Solid, Color("rgba(220,38,38,0.12)"))
    }

    val profileSecurityTitle by style {
        fontSize(12.px)
        fontWeight(600)
        color(Color("rgba(15,23,42,0.55)"))
        property("letter-spacing", "0.04em")
        marginBottom(14.px)
    }

    val profileSecurityActions by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(10.px)
    }

    val profileSecurityLogout by style {
        fontSize(13.px)
        fontWeight(500)
        color(Color("rgba(15,23,42,0.75)"))
        backgroundColor(Color.transparent)
        border(0.px)
        property("cursor", "pointer")
        property("text-align", "left")
        self + hover style { color(Color("rgba(15,23,42,0.9)")) }
    }

    val profileSecurityDelete by style {
        fontSize(13.px)
        fontWeight(500)
        color(Color("rgba(185,28,28,0.85)"))
        backgroundColor(Color.transparent)
        border(0.px)
        property("cursor", "pointer")
        property("text-align", "left")
        self + hover style { color(Color("rgba(185,28,28,0.95)")) }
    }

    // ---------- Configuration : header incarné, blocs Ton IA + Signature ----------
    val configPageSubtitle by style {
        fontSize(13.px)
        fontWeight(400)
        color(Color("rgba(15,23,42,0.55)"))
        lineHeight("1.5")
        marginTop(4.px)
        marginBottom(0.px)
    }

    val configHeaderDivider by style {
        marginTop(20.px)
        marginBottom(32.px)
        property("border-top", "1px solid rgba(15,23,42,0.08)")
    }

    /** Bloc section : plus d'air entre sections. */
    val configBlock by style {
        marginBottom(48.px)
    }

    /** 2e bloc : séparation visuelle (trait + marge). */
    val configBlockWithTopSpacer by style {
        marginTop(40.px)
        paddingTop(24.px)
        property("border-top", "1px solid rgba(15,23,42,0.06)")
    }

    /** Titre de section = mini-chapitre : plus gros, bold, espacé au-dessus. */
    val configBlockTitle by style {
        fontSize(15.px)
        fontWeight(700)
        color(Color("rgba(15,23,42,0.9)"))
        property("letter-spacing", "0.02em")
        marginTop(20.px)
        marginBottom(6.px)
    }

    val configBlockTitleFirst by style {
        marginTop(0.px)
    }

    /** Titre dans une row (ex. Signature + toggle) : même style, sans marge verticale. */
    val configBlockTitleInRow by style {
        fontSize(15.px)
        fontWeight(700)
        color(Color("rgba(15,23,42,0.9)"))
        property("letter-spacing", "0.02em")
    }

    /** Ligne titre + contrôle (ex. Signature + toggle), même poids titre. */
    val configBlockTitleRow by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Row)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.SpaceBetween)
        gap(12.px)
        marginTop(20.px)
        marginBottom(0.px)
        minWidth(0.px)
    }

    val configBlockTitleRowFirst by style {
        marginTop(0.px)
    }

    /** Descriptions : allégées, secondaires. */
    val configBlockDescription by style {
        fontSize(12.px)
        fontWeight(400)
        color(Color("rgba(15,23,42,0.48)"))
        lineHeight("1.5")
        marginBottom(14.px)
    }

    /** Ligne sous le slider : badge "Ton actuel" à droite. */
    val configToneCurrentRow by style {
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.FlexEnd)
        marginTop(6.px)
    }

    val configToneCurrent by style {
        fontSize(11.px)
        fontWeight(500)
        color(Color("rgba(15,23,42,0.5)"))
    }

    /** Légende des 3 pôles : peu d'air interne. */
    val configToneLabels by style {
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.SpaceBetween)
        marginTop(8.px)
        paddingLeft(0.px)
        paddingRight(0.px)
    }

    val configToneLegendLabel by style {
        fontSize(11.px)
        fontWeight(400)
        color(Color("rgba(15,23,42,0.45)"))
        border(0.px)
        backgroundColor(Color.transparent)
        property("cursor", "pointer")
        padding(0.px, 4.px)
    }

    val configToneLegendLabelActive by style {
        color(Color("rgba(102,96,230,0.75)"))
        fontWeight(500)
    }

    /** Mini-card pour le textarea signature (comme bloc Gmail). */
    val configSignatureCard by style {
        padding(18.px, 16.px)
        borderRadius(12.px)
        backgroundColor(Color("rgba(15,23,42,0.03)"))
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.08)"))
        marginTop(10.px)
    }

    /** Header de section (minimal) : titre compact, sous-titre discret. */
    val accountHero by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Row)
        justifyContent(JustifyContent.SpaceBetween)
        alignItems(AlignItems.Center)
        paddingTop(0.px)
        paddingBottom(0.px)
        marginBottom(16.px)
        minWidth(0.px)
    }

    val accountHeroLeft by style {
        minWidth(0.px)
    }

    val accountHeroTitle by style {
        fontSize(22.px)
        fontWeight(600)
        color(Color(AppStylesTokens.INK))
        property("letter-spacing", "-0.02em")
        marginBottom(2.px)
        property("line-height", "1.25")
    }

    val accountHeroSub by style {
        fontSize(12.px)
        fontWeight(400)
        color(Color("rgba(15,23,42,0.48)"))
        lineHeight("1.4")
    }

    /** Section : titre + hairline + contenu. Espace Hero → Section 48px, Section → Section 56px. */
    val accountSection by style {
        marginBottom(56.px)
    }

    /** Ligne titre de section + action (ex. Profil + Déconnexion). */
    val accountSectionTitleRow by style {
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.SpaceBetween)
        alignItems(AlignItems.Center)
        marginBottom(24.px)
        paddingBottom(12.px)
        property("border-bottom", "1px solid rgba(15,23,42,0.08)")
    }

    /** Titre de section lorsqu’il est dans une row (sans marge ni bordure). */
    val accountSectionTitleInRow by style {
        fontSize(15.px)
        fontWeight(700)
        color(Color("rgba(15,23,42,0.9)"))
    }

    val accountSectionTitle by style {
        fontSize(15.px)
        fontWeight(700)
        color(Color("rgba(15,23,42,0.9)"))
        marginBottom(24.px)
        paddingBottom(12.px)
        property("border-bottom", "1px solid rgba(15,23,42,0.08)")
    }

    val accountSectionContent by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(16.px)
    }

    val accountTeamSub by style {
        marginBottom(24.px)
    }

    /** Sous-titre de bloc dans la section Équipe (Invitations en attente, Membres). */
    val accountTeamSectionLabel by style {
        fontSize(12.px)
        fontWeight(600)
        color(Color("rgba(15,23,42,0.55)"))
        property("letter-spacing", "0.02em")
        marginTop(20.px)
        marginBottom(8.px)
    }

    val accountTeamSectionLabelFirst by style {
        marginTop(0.px)
    }

    /** Slider premium : track 4px, curseur subtil. */
    val accountSliderTrack by style {
        width(100.percent)
        height(4.px)
        borderRadius(999.px)
        backgroundColor(Color("rgba(15,23,42,0.08)"))
        property("cursor", "pointer")
        property("appearance", "none")
        property("-webkit-appearance", "none")
    }

    val accountSliderLabels by style {
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.SpaceBetween)
        marginTop(12.px)
        fontSize(12.px)
        fontWeight(500)
        color(Color("rgba(15,23,42,0.55)"))
    }

    /** Toggle élégant (signature). */
    val accountToggleRow by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.SpaceBetween)
        gap(16.px)
    }

    /** Textarea compact : max-width 640px, hauteur réduite. */
    val accountTextareaWrap by style {
        maxWidth(640.px)
    }

    val accountTextareaCompact by style {
        width(100.percent)
        padding(12.px, 14.px)
        borderRadius(10.px)
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.1)"))
        fontSize(13.px)
        lineHeight("1.5")
        property("min-height", "80px")
        property("resize", "vertical")
        property("font-family", AppStylesTokens.FONT_FAMILY)
    }

    /** Section Équipe : liste élégante hairlines, pas de grosses cards. */
    val accountTeamInviteRow by style {
        display(DisplayStyle.Flex)
        gap(12.px)
        alignItems(AlignItems.Center)
        marginBottom(16.px)
    }

    val accountTeamInput by style {
        padding(10.px, 14.px)
        borderRadius(8.px)
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.1)"))
        fontSize(14.px)
        property("flex", "1")
        minWidth(0.px)
    }

    val accountTeamBtnSend by style {
        padding(10.px, 18.px)
        borderRadius(8.px)
        border(0.px)
        backgroundColor(Color("rgba(102,96,230,0.75)"))
        color(Color.white)
        fontSize(13.px)
        fontWeight(500)
        property("cursor", "pointer")
    }

    val accountTeamList by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
    }

    val accountTeamRow by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.SpaceBetween)
        padding(10.px, 0.px)
        property("border-bottom", "1px solid rgba(15,23,42,0.06)")
        gap(12.px)
    }

    val accountTeamRowLast by style {
        property("border-bottom", "none")
    }

    val accountTeamEmail by style {
        fontSize(14.px)
        color(Color("rgba(15,23,42,0.85)"))
        property("flex", "1")
        minWidth(0.px)
        property("word-break", "break-all")
    }

    val accountTeamRole by style {
        fontSize(12.px)
        fontWeight(500)
        color(Color("rgba(15,23,42,0.55)"))
    }

    val accountTeamRevoke by style {
        fontSize(12.px)
        fontWeight(500)
        color(Color("rgba(15,23,42,0.5)"))
        backgroundColor(Color.transparent)
        border(0.px)
        property("cursor", "pointer")
        self + hover style { color(Color("rgba(185,28,28,0.85)")) }
    }

    // ---------- Équipe : header incarné, blocs Inviter / Invitations / Membres ----------
    val teamPageSubtitle by style {
        fontSize(13.px)
        fontWeight(400)
        color(Color("rgba(15,23,42,0.55)"))
        lineHeight("1.5")
        marginTop(4.px)
        marginBottom(0.px)
    }

    val teamHeaderDivider by style {
        marginTop(20.px)
        marginBottom(16.px)
        property("border-top", "1px solid rgba(15,23,42,0.08)")
    }

    /** Ligne stats : "2 membres • 0 invitation en attente". */
    val teamStatsLine by style {
        fontSize(12.px)
        fontWeight(500)
        color(Color("rgba(15,23,42,0.5)"))
        marginBottom(32.px)
    }

    val teamBlock by style {
        marginBottom(48.px)
    }

    val teamBlockWithTopSpacer by style {
        marginTop(40.px)
        paddingTop(24.px)
        property("border-top", "1px solid rgba(15,23,42,0.06)")
    }

    val teamBlockTitle by style {
        fontSize(15.px)
        fontWeight(700)
        color(Color("rgba(15,23,42,0.9)"))
        property("letter-spacing", "0.02em")
        marginTop(20.px)
        marginBottom(6.px)
    }

    val teamBlockTitleFirst by style {
        marginTop(0.px)
    }

    val teamBlockDescription by style {
        fontSize(12.px)
        fontWeight(400)
        color(Color("rgba(15,23,42,0.48)"))
        lineHeight("1.5")
        marginBottom(14.px)
    }

    /** Ligne input + bouton Envoyer. */
    val teamInviteRow by style {
        display(DisplayStyle.Flex)
        gap(12.px)
        alignItems(AlignItems.Center)
        marginBottom(8.px)
    }

    val teamInviteInput by style {
        padding(10.px, 14.px)
        borderRadius(10.px)
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.12)"))
        fontSize(14.px)
        property("flex", "1")
        minWidth(0.px)
    }

    val teamInviteBtn by style {
        padding(10.px, 20.px)
        borderRadius(10.px)
        border(0.px)
        backgroundColor(Color("rgba(102,96,230,0.8)"))
        color(Color.white)
        fontSize(13.px)
        fontWeight(600)
        property("cursor", "pointer")
        property("flex-shrink", "0")
    }

    val teamInviteHint by style {
        fontSize(11.px)
        fontWeight(400)
        color(Color("rgba(15,23,42,0.45)"))
    }

    /** Row structurée : email + badge/action à droite. */
    val teamListRow by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.SpaceBetween)
        gap(12.px)
        padding(12.px, 0.px)
        property("border-bottom", "1px solid rgba(15,23,42,0.06)")
        minWidth(0.px)
    }

    val teamListRowLast by style {
        property("border-bottom", "none")
    }

    val teamListEmail by style {
        fontSize(14.px)
        fontWeight(400)
        color(Color("rgba(15,23,42,0.72)"))
        property("flex", "1")
        minWidth(0.px)
        property("word-break", "break-all")
    }

    /** Groupe à droite : badge(s) + action. */
    val teamListRight by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(10.px)
        flexShrink(0)
    }

    /** Badge statut invitation : En attente / Acceptée. */
    val teamStatusBadge by style {
        display(DisplayStyle.InlineBlock)
        padding(4.px, 10.px)
        borderRadius(6.px)
        fontSize(11.px)
        fontWeight(600)
        color(Color("rgba(15,23,42,0.65)"))
        backgroundColor(Color("rgba(15,23,42,0.07)"))
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.1)"))
    }

    val teamStatusBadgeAccepted by style {
        color(Color("rgba(34,119,34,0.85)"))
        backgroundColor(Color("rgba(34,119,34,0.08)"))
        border(1.px, LineStyle.Solid, Color("rgba(34,119,34,0.18)"))
    }

    /** Badge rôle : Owner plus marqué, Membre discret. */
    val teamRoleBadge by style {
        display(DisplayStyle.InlineBlock)
        padding(5.px, 11.px)
        borderRadius(6.px)
        fontSize(11.px)
        fontWeight(600)
        color(Color("rgba(15,23,42,0.7)"))
        backgroundColor(Color("rgba(15,23,42,0.08)"))
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.12)"))
    }

    val teamRoleBadgeOwner by style {
        color(Color("rgba(102,96,230,0.9)"))
        backgroundColor(Color("rgba(102,96,230,0.1)"))
        border(1.px, LineStyle.Solid, Color("rgba(102,96,230,0.22)"))
    }

    /** Action Retirer / Révoquer : gris interactif, clairement cliquable sans rivaliser. */
    val teamRowAction by style {
        fontSize(12.px)
        fontWeight(500)
        color(Color("rgba(15,23,42,0.64)"))
        backgroundColor(Color.transparent)
        border(0.px)
        property("cursor", "pointer")
        self + hover style { color(Color("rgba(185,28,28,0.85)")) }
    }

    /** Abonnement sobre. */
    val accountAboPlan by style {
        fontSize(14.px)
        color(Color("rgba(15,23,42,0.78)"))
        marginBottom(16.px)
    }

    val accountAboLink by style {
        fontSize(13.px)
        fontWeight(500)
        color(Color(AppStylesTokens.BRAND))
        backgroundColor(Color.transparent)
        border(0.px)
        property("cursor", "pointer")
        self + hover style { property("text-decoration", "underline") }
    }

    /** Carte Abonnement V1 : bloc principal (plan, prix, statut, CTA). */
    val accountAboCard by style {
        padding(20.px)
        borderRadius(12.px)
        backgroundColor(Color("rgba(15,23,42,0.03)"))
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.08)"))
        marginTop(16.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(16.px)
    }

    val accountAboPlanRow by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Row)
        justifyContent(JustifyContent.SpaceBetween)
        alignItems(AlignItems.Center)
    }

    val accountAboPlanLabel by style {
        fontSize(12.px)
        fontWeight(600)
        color(Color("rgba(15,23,42,0.55)"))
    }

    val accountAboPlanValue by style {
        fontSize(15.px)
        fontWeight(600)
        color(Color(AppStylesTokens.INK))
    }

    /** Bloc valeur + sous-ligne aligné à droite dans la row. */
    val accountAboPlanValueBlock by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        alignItems(AlignItems.FlexEnd)
    }

    /** Sous-ligne (description plan, "facturé mensuellement"). */
    val accountAboPlanSub by style {
        fontSize(12.px)
        color(Color("rgba(15,23,42,0.55)"))
        marginTop(2.px)
    }

    val accountAboStatusLine by style {
        fontSize(14.px)
        color(Color("rgba(15,23,42,0.78)"))
        lineHeight("1.4")
    }

    /** Jours restants en warning quand <= 3. */
    val accountAboStatusWarning by style {
        fontSize(14.px)
        color(Color(AppStylesTokens.STATUS_WAITING))
        fontWeight(600)
        lineHeight("1.4")
    }

    val accountAboCta by style {
        marginTop(8.px)
        padding(12.px, 20.px)
        fontSize(14.px)
        fontWeight(600)
        color(Color.white)
        backgroundColor(Color(AppStylesTokens.BRAND))
        border(0.px)
        borderRadius(8.px)
        property("cursor", "pointer")
        self + hover style { backgroundColor(Color(AppStylesTokens.NAV_ACTIVE)) }
    }

    val accountAboMessageSecondary by style {
        fontSize(12.px)
        color(Color("rgba(15,23,42,0.55)"))
        marginTop(4.px)
    }

    /** Zone sensible Supprimer en bas de page. */
    val accountDangerZone by style {
        marginTop(32.px)
        paddingTop(24.px)
        property("border-top", "1px solid rgba(15,23,42,0.06)")
    }

    val accountDangerZoneLabel by style {
        fontSize(12.px)
        fontWeight(500)
        color(Color("rgba(15,23,42,0.5)"))
        marginBottom(6.px)
    }

    val accountDangerZoneLink by style {
        fontSize(14.px)
        fontWeight(500)
        color(Color("rgba(185,28,28,0.82)"))
        backgroundColor(Color.transparent)
        border(0.px)
        property("cursor", "pointer")
        self + hover style { color(Color("rgba(185,28,28,0.95)")) }
    }

    /** Déconnexion aligné à droite sur la même ligne que le titre "Mon compte". */
    val accountLogoutWrap by style {
        flexShrink(0)
    }

    val accountLogoutBtn by style {
        fontSize(13.px)
        fontWeight(500)
        color(Color("rgba(15,23,42,0.6)"))
        backgroundColor(Color.transparent)
        border(0.px)
        property("cursor", "pointer")
        self + hover style { color(Color("rgba(15,23,42,0.85)")) }
    }

    // ---------- Billing Gate (vue blocage produit premium) ----------
    /** Bloc central unique : largeur adaptée à la carte 560px. */
    val billingGatePage by style {
        maxWidth(620.px)
        property("margin", "0 auto")
        padding(32.px, 24.px, 48.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(0.px)
    }

    /** Hero titre gate : présence, pas trop gros. */
    val billingGateHeroTitle by style {
        fontSize(24.px)
        fontWeight(600)
        property("line-height", "1.25")
        property("text-align", "center")
        marginBottom(8.px)
        color(Color(AppStylesTokens.INK))
    }

    /** Sous-titre gate : direct, centré. */
    val billingGateHeroSub by style {
        fontSize(15.px)
        color(Color(AppStylesTokens.MUTED))
        property("text-align", "center")
        lineHeight("1.45")
        marginBottom(20.px)
    }

    /** Bandeau d'état : Essai expiré / accès suspendu — beige/ambre doux. */
    val billingGateStatusBanner by style {
        padding(14.px, 18.px)
        borderRadius(12.px)
        backgroundColor(Color("rgba(180,83,9,0.08)"))
        border(1.px, LineStyle.Solid, Color("rgba(180,83,9,0.2)"))
        marginBottom(24.px)
    }

    val billingGateStatusLabel by style {
        fontSize(12.px)
        fontWeight(600)
        color(Color(AppStylesTokens.STATUS_WAITING))
        property("letter-spacing", "0.03em")
        marginBottom(4.px)
    }

    val billingGateStatusText by style {
        fontSize(14.px)
        color(Color("rgba(15,23,42,0.78)"))
        lineHeight("1.4")
    }

    /** Carte principale gate : cœur de l'écran, 560px de large. */
    val billingGateCard by style {
        width(560.px)
        padding(28.px)
        borderRadius(16.px)
        backgroundColor(Color(AppStylesTokens.SURFACE))
        border(1.px, LineStyle.Solid, Color(AppStylesTokens.BORDER))
        property("box-shadow", "0 4px 24px rgba(15,23,42,0.06)")
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(20.px)
    }

    /** Ligne prix + CTA : 99 € / mois — Activer AppSyde. */
    val billingGateCardHead by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Row)
        justifyContent(JustifyContent.SpaceBetween)
        alignItems(AlignItems.Center)
    }

    val billingGateCardPlan by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(4.px)
    }

    val billingGateCardPlanName by style {
        fontSize(18.px)
        fontWeight(600)
        color(Color(AppStylesTokens.INK))
    }

    val billingGateCardPlanBadge by style {
        fontSize(11.px)
        fontWeight(600)
        color(Color(AppStylesTokens.BRAND))
        backgroundColor(Color(AppStylesTokens.BRAND_SOFT))
        padding(3.px, 8.px)
        borderRadius(6.px)
        display(DisplayStyle.InlineBlock)
        property("width", "fit-content")
    }

    val billingGateCardPrice by style {
        fontSize(22.px)
        fontWeight(600)
        color(Color(AppStylesTokens.INK))
    }

    /** Micro-copy sous CTA (Stripe). */
    val billingGateCtaSub by style {
        fontSize(12.px)
        color(Color(AppStylesTokens.MUTED))
        property("text-align", "center")
    }

    /** CTA gate : plus haut, plus assumé. */
    val billingGateCta by style {
        height(48.px)
        borderRadius(10.px)
        fontSize(16.px)
        fontWeight(600)
        width(100.percent)
        color(Color.white)
        backgroundColor(Color(AppStylesTokens.BRAND))
        border(0.px)
        property("cursor", "pointer")
        self + hover style { backgroundColor(Color(AppStylesTokens.NAV_ACTIVE)) }
    }

    /** Divider subtil avant workspace dans la carte. */
    val billingGateCardDivider by style {
        height(1.px)
        backgroundColor(Color(AppStylesTokens.BORDER))
        property("margin", "4px 0")
    }

    /** Workspace intégré : une ligne compacte. */
    val billingGateWorkspaceLine by style {
        fontSize(13.px)
        color(Color(AppStylesTokens.MUTED))
        lineHeight("1.4")
    }

    val billingGateWorkspaceLabel by style {
        fontSize(11.px)
        fontWeight(600)
        color(Color("rgba(15,23,42,0.5)"))
        property("letter-spacing", "0.03em")
        marginBottom(6.px)
    }

    /** Réassurance : une ligne sous le bloc. */
    val billingGateReassurance by style {
        fontSize(13.px)
        color(Color(AppStylesTokens.MUTED))
        property("text-align", "center")
        lineHeight("1.45")
        marginTop(20.px)
    }

    /** Ancien message d'état (conservé pour compat). */
    val billingGateCardState by style {
        fontSize(14.px)
        color(Color(AppStylesTokens.MUTED))
        marginBottom(20.px)
        lineHeight("1.4")
    }

    // ---------- Page Activation Abonnement (Hero → Plan → Valeur → Workspace → FAQ → Paiement) ----------
    /** Conteneur page : max-width 760px, centré, padding 48px 24px. */
    val aboActivationPage by style {
        maxWidth(760.px)
        property("margin", "0 auto")
        padding(48.px, 24.px)
    }

    /** Hero titre : Activer AppSyde. */
    val aboActivationHeroTitle by style {
        fontSize(28.px)
        fontWeight(600)
        property("line-height", "1.2")
        property("text-align", "center")
        marginBottom(8.px)
        color(Color(AppStylesTokens.INK))
    }

    /** Hero sous-titre (text-secondary). */
    val aboActivationHeroSub by style {
        fontSize(16.px)
        color(Color(AppStylesTokens.MUTED))
        maxWidth(520.px)
        property("margin", "0 auto")
        property("text-align", "center")
        lineHeight("1.5")
        marginBottom(0.px)
    }

    /** Bandeau essai gratuit en cours (entre Hero et carte plan). */
    val aboActivationTrialBanner by style {
        maxWidth(520.px)
        property("margin", "16px auto 0")
        padding(16.px, 20.px)
        borderRadius(12.px)
        backgroundColor(Color(AppStylesTokens.STATUS_WAITING_SOFT))
        border(1.px, LineStyle.Solid, Color("rgba(154,70,8,0.25)"))
        property("text-align", "center")
    }

    val aboActivationTrialLabel by style {
        fontSize(14.px)
        fontWeight(600)
        color(Color(AppStylesTokens.INK))
    }

    val aboActivationTrialDays by style {
        fontSize(14.px)
        color(Color(AppStylesTokens.MUTED))
        marginTop(4.px)
        lineHeight("1.4")
    }

    val aboActivationTrialDaysWarning by style {
        fontSize(14.px)
        fontWeight(600)
        color(Color(AppStylesTokens.STATUS_WAITING))
        marginTop(4.px)
        lineHeight("1.4")
    }

    /** Carte plan centrale : max-width 520px, padding 32px, border-radius 16px. */
    val aboActivationPlanCard by style {
        maxWidth(520.px)
        property("margin", "20px auto 0")
        padding(32.px)
        borderRadius(16.px)
        backgroundColor(Color(AppStylesTokens.SURFACE))
        border(1.px, LineStyle.Solid, Color(AppStylesTokens.BORDER))
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
    }

    /** Header carte : titre + badge | prix. */
    val aboActivationPlanCardHeader by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Row)
        justifyContent(JustifyContent.SpaceBetween)
        alignItems(AlignItems.FlexStart)
    }

    /** Bloc titre + badge (gauche). */
    val aboActivationPlanCardTitleBlock by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(6.px)
    }

    val aboActivationPlanCardTitle by style {
        fontSize(20.px)
        fontWeight(600)
        color(Color(AppStylesTokens.INK))
    }

    /** Badge type "Plan équipe". */
    val aboActivationPlanCardBadge by style {
        display(DisplayStyle.InlineBlock)
        fontSize(11.px)
        fontWeight(600)
        color(Color(AppStylesTokens.BRAND))
        backgroundColor(Color(AppStylesTokens.BRAND_SOFT))
        padding(4.px, 8.px)
        borderRadius(6.px)
        property("letter-spacing", "0.02em")
    }

    /** Bloc prix (droite) : 99 € + / mois + Jusqu'à 5 agents. */
    val aboActivationPlanCardPriceBlock by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        alignItems(AlignItems.FlexEnd)
    }

    /** Prix en gros : 99 €. */
    val aboActivationPlanCardPriceBig by style {
        fontSize(36.px)
        fontWeight(600)
        color(Color(AppStylesTokens.INK))
        property("line-height", "1.1")
    }

    /** Période : / mois. */
    val aboActivationPlanCardPricePeriod by style {
        fontSize(14.px)
        fontWeight(500)
        color(Color(AppStylesTokens.MUTED))
        marginTop(2.px)
    }

    val aboActivationPlanCardPrice by style {
        fontSize(18.px)
        fontWeight(600)
        color(Color(AppStylesTokens.INK))
    }

    /** Sous-texte sous le prix : Jusqu'à 5 agents. */
    val aboActivationPlanCardSub by style {
        fontSize(13.px)
        color(Color(AppStylesTokens.MUTED))
        marginTop(6.px)
    }

    /** Liste features : gap 8px, margin-top 20px. */
    val aboActivationPlanFeatures by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(8.px)
        marginTop(20.px)
    }

    val aboActivationPlanFeatureItem by style {
        fontSize(14.px)
        color(Color("rgba(15,23,42,0.82)"))
        lineHeight("1.4")
    }

    /** CTA principal : Activer AppSyde. */
    val aboActivationPlanCta by style {
        height(44.px)
        borderRadius(10.px)
        fontWeight(500)
        width(100.percent)
        marginTop(24.px)
        fontSize(15.px)
        color(Color.white)
        backgroundColor(Color(AppStylesTokens.BRAND))
        border(0.px)
        property("cursor", "pointer")
        self + hover style { backgroundColor(Color(AppStylesTokens.NAV_ACTIVE)) }
    }

    /** Sous-texte CTA : Paiement sécurisé par Stripe, Annulation à tout moment. */
    val aboActivationPlanCtaSub by style {
        fontSize(13.px)
        color(Color(AppStylesTokens.MUTED))
        property("text-align", "center")
        marginTop(10.px)
    }

    /** Section Pourquoi utiliser AppSyde ? */
    val aboActivationValueSection by style {
        marginTop(48.px)
    }

    val aboActivationValueTitle by style {
        fontSize(18.px)
        fontWeight(600)
        color(Color(AppStylesTokens.INK))
        marginBottom(24.px)
    }

    val aboActivationValueCards by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(24.px)
    }

    val aboActivationValueCard by style {
        padding(20.px)
        borderRadius(12.px)
        backgroundColor(Color("rgba(15,23,42,0.02)"))
        border(1.px, LineStyle.Solid, Color(AppStylesTokens.BORDER))
    }

    val aboActivationValueCardTitle by style {
        fontSize(15.px)
        fontWeight(600)
        color(Color(AppStylesTokens.INK))
        marginBottom(8.px)
    }

    val aboActivationValueCardText by style {
        fontSize(14.px)
        color(Color(AppStylesTokens.MUTED))
        lineHeight("1.5")
    }

    /** Section Workspace à activer. */
    val aboActivationWorkspaceSection by style {
        marginTop(48.px)
    }

    val aboActivationWorkspaceTitle by style {
        fontSize(18.px)
        fontWeight(600)
        color(Color(AppStylesTokens.INK))
        marginBottom(16.px)
    }

    val aboActivationWorkspaceCard by style {
        padding(20.px)
        borderRadius(12.px)
        backgroundColor(Color("rgba(15,23,42,0.02)"))
        border(1.px, LineStyle.Solid, Color(AppStylesTokens.BORDER))
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(8.px)
    }

    val aboActivationWorkspaceRow by style {
        fontSize(14.px)
        color(Color("rgba(15,23,42,0.82)"))
    }

    /** Section FAQ. */
    val aboActivationFaqSection by style {
        marginTop(48.px)
    }

    val aboActivationFaqTitle by style {
        fontSize(18.px)
        fontWeight(600)
        color(Color(AppStylesTokens.INK))
        marginBottom(20.px)
    }

    val aboActivationFaqList by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
    }

    /** Item FAQ : bordure haute + espace pour aérer. */
    val aboActivationFaqItem by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(8.px)
        paddingTop(24.px)
        marginTop(24.px)
        property("border-top", "1px solid rgba(15,23,42,0.08)")
    }

    /** Premier item FAQ : pas de bordure ni marge au-dessus. */
    val aboActivationFaqItemFirst by style {
        paddingTop(0.px)
        marginTop(0.px)
        property("border-top", "none")
    }

    val aboActivationFaqQuestion by style {
        fontSize(14.px)
        fontWeight(600)
        color(Color(AppStylesTokens.INK))
    }

    val aboActivationFaqAnswer by style {
        fontSize(14.px)
        color(Color(AppStylesTokens.MUTED))
        lineHeight("1.5")
    }

    /** Section Paiement (titre + texte + CTA). */
    val aboActivationPaymentSection by style {
        marginTop(48.px)
        paddingTop(32.px)
        property("border-top", "1px solid rgba(15,23,42,0.08)")
    }

    val aboActivationPaymentTitle by style {
        fontSize(18.px)
        fontWeight(600)
        color(Color(AppStylesTokens.INK))
        marginBottom(8.px)
    }

    val aboActivationPaymentText by style {
        fontSize(14.px)
        color(Color(AppStylesTokens.MUTED))
        marginBottom(24.px)
    }

    /** Conteneur page succès : flex colonne pour que la zone suivante prenne la hauteur restante. */
    val billingSuccessPageWrap by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        property("flex", "1")
        minHeight(0.px)
    }

    /** Bloc icône + titre page succès : en colonne (titre sous l’icône). */
    val billingSuccessTitleBlock by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        alignItems(AlignItems.FlexStart)
        gap(14.px)
        marginBottom(20.px)
    }

    /** Espace au-dessus du bouton page succès. */
    val billingSuccessCtaWrap by style {
        marginTop(28.px)
    }

    /** Texte sous le bouton : « Redirection automatique vers vos tickets… » */
    val billingSuccessRedirectHint by style {
        fontSize(13.px)
        color(Color("#6B7280"))
        marginTop(12.px)
    }

    /** Zone contenu page succès abonnement : prend la hauteur restante et centre la carte. */
    val billingSuccessContentWrap by style {
        property("flex", "1")
        minHeight(0.px)
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.Center)
        alignItems(AlignItems.Center)
        padding(28.px)
    }

    /** Écran succès après paiement. */
    val aboSuccessWrap by style {
        maxWidth(520.px)
        property("margin", "0 auto")
        padding(48.px, 24.px)
        property("text-align", "center")
    }

    val aboSuccessTitle by style {
        fontSize(28.px)
        fontWeight(600)
        color(Color(AppStylesTokens.INK))
        marginBottom(12.px)
    }

    val aboSuccessText by style {
        fontSize(16.px)
        color(Color(AppStylesTokens.MUTED))
        lineHeight("1.5")
        marginBottom(24.px)
    }

    val aboSuccessCta by style {
        height(44.px)
        padding(0.px, 24.px)
        borderRadius(10.px)
        fontSize(15.px)
        fontWeight(500)
        color(Color.white)
        backgroundColor(Color(AppStylesTokens.BRAND))
        border(0.px)
        property("cursor", "pointer")
        self + hover style { backgroundColor(Color(AppStylesTokens.NAV_ACTIVE)) }
    }

}
